const versionInjectee = import.meta.env["VITE_BUILD_VERSION"];

/** Identifiant immuable du build affiché dans le shell et les diagnostics visuels. */
export const VERSION_BUILD =
  typeof versionInjectee === "string" && versionInjectee.trim() ? versionInjectee.trim() : "local";

export const LIBELLE_VERSION_BUILD = `Build ${VERSION_BUILD}`;
